import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles, Loader2, Lock } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/login", { email, password });
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-8">
          <Sparkles className="w-6 h-6 text-gold" />
          <span className="font-serif text-3xl text-ivory">Aetheria Admin</span>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl" data-testid="admin-login-form">
          <div className="w-12 h-12 rounded-full bg-gold-subtle flex items-center justify-center mx-auto mb-5">
            <Lock className="w-5 h-5 text-gold-hover" />
          </div>
          <h1 className="font-serif text-2xl text-navy text-center mb-6">Sign in to continue</h1>
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
              <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@…" aria-label="Email" />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Password</label>
              <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" aria-label="Password" />
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-primary w-full mt-6">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
